import React from 'react'

const SearchBoldIcon = () => {
    return (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.41667 11.8333C9.40821 11.8333 11.8333 9.40821 11.8333 6.41667C11.8333 3.42513 9.40821 1 6.41667 1C3.42513 1 1 3.42513 1 6.41667C1 9.40821 3.42513 11.8333 6.41667 11.8333Z" stroke="#352D2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.9997 13.9977L10.2441 10.2422" stroke="#352D2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default SearchBoldIcon